module.exports = __webpack_public_path__ + "img/icon_option_set.a42420ee.svg";